import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { NotifyService } from '../services/notify.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private routeS: Router,
    private notifyS: NotifyService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        next: (event: any) => {
          if (event instanceof HttpResponse) {
            console.log(event.body)
            let resStatusCode = event.body.status
            let resMsg: string = String(event.body.message)

            //alert(`${resMsg}: ${resStatusCode}`)

            if (resStatusCode === 200 || resStatusCode === '200') {
              if (resMsg.includes('no') || resMsg.includes('not')) {
                this.notifyS.warning('', resMsg)
              } else if (resMsg.includes('error')) {
                this.notifyS.error('', resMsg)
              }
              else {
                this.notifyS.success('', resMsg)
              }
            }
            else if (resStatusCode === 401 || resStatusCode === 403) {
              this.notifyS.error('', resMsg)
              sessionStorage.clear()
              localStorage.clear()
              this.routeS.navigate(['/login'])
            } else {
              this.notifyS.error('', resMsg)
            }
          }
          return event
        }
      })
    )
  }
}

export const ErrorInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ErrorInterceptor,
  multi: true,
}
